import { S as Swiper } from './swiper-core-Bbvcim4W.js';
import { N as Navigation } from './navigation-DRozqAD1.js';
import { A as A11y } from './a11y-SU9kYSAf.js';

class ProductGemPicker extends HTMLElement {
  productCard = this.closest('[data-product-card]');
  featuredImage = this.productCard.querySelector('[data-product-card-featured-image] img');
  hoverImage = this.productCard.querySelector('[data-product-card-hover-image] img');
  links = this.productCard.querySelectorAll('[data-product-card-url]');
  price = this.productCard.querySelector('[data-product-card-price]');
  gemOptions = this.productCard.querySelectorAll('[data-product-gem-picker-option]');
  badges = this.productCard.querySelector('.product-card__badges .badges');
  swiperInstance = null;
  observer = null;

  connectedCallback() {
    this.initializeSwiper();
    this.setupEventListeners();
    this.setupResizeObserver();
  }

  setupEventListeners() {
    this.gemOptions.forEach((option) => {
      option.addEventListener('click', (event) => this.handleClick(event));
    });
  }

  setupResizeObserver() {
    this.observer = new ResizeObserver((entries) => this.handleResize(entries));
    this.observer.observe(this.querySelector('.swiper-wrapper'));
  }

  initializeSwiper() {
    this.swiperElement = this.querySelector('.swiper');
    if (!this.swiperElement) return;

    this.swiperInstance = new Swiper(this.swiperElement, {
      modules: [A11y, Navigation],
      centerInsufficientSlides: true,
      nested: true,
      slidesPerView: 'auto',
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  handleResize(entries) {
    for (const entry of entries) {
      if (entry.contentRect && this.swiperInstance) {
        this.updateSwiper();
      } else if (!this.swiperInstance) {
        this.initializeSwiper();
      }
    }
  }

  updateSwiper() {
    if (!this.swiperInstance) return;

    this.swiperInstance.params.slidesPerView = 'auto';
    this.swiperInstance.update();
  }

  handleClick(event) {
    const { currentTarget } = event;
    const gemData = this.extractGemData(currentTarget);

    this.updateProductDisplay(gemData);
    this.handleBadges(gemData);
  }

  extractGemData(target) {
    return {
      gemId: target.dataset.gemVariantId,
      featuredImage: target.dataset.gemVariantFeaturedImage,
      featuredImageAlt: target.dataset.gemVariantFeaturedImageAlt,
      hoverImage: target.dataset.gemVariantHoverImage,
      url: target.dataset.gemVariantUrl,
      price: target.querySelector('[data-gem-variant-price]').content.cloneNode(true),
      badges: target.querySelector('[data-gem-variant-badges]').content.cloneNode(true),
    };
  }

  updateProductDisplay(gemData) {
    this.updateSelectedState(gemData);
    this.updateImages(gemData);
    this.updatePrice(gemData);
    this.updateLinks(gemData);
  }

  updateSelectedState(gemData) {
    this.gemOptions.forEach((option) => option.classList.remove('selected'));
    this.querySelector(`[data-gem-variant-id="${gemData.gemId}"]`).classList.add('selected');
    this.dataset.currentGemVariantId = gemData.gemId;
  }

  updateImages(gemData) {
    this.updateFeaturedImage(gemData);
    this.updateHoverImage(gemData);
  }

  updateFeaturedImage(gemData) {
    if (!this.featuredImage) return;

    this.featuredImage.srcset = '';
    this.featuredImage.src = gemData.featuredImage;
    this.featuredImage.alt = gemData.featuredImageAlt;
  }

  updateHoverImage(gemData) {
    if (!this.hoverImage) return;

    this.hoverImage.srcset = '';
    this.hoverImage.src = gemData.hoverImage;
    this.hoverImage.classList.toggle('hidden', !gemData.hoverImage);
  }

  updatePrice({ price }) {
    const priceContainer = price.querySelector('[data-product-card-price]');
    this.price.innerHTML = priceContainer?.innerHTML || '';
  }

  updateLinks({ url }) {
    this.links.forEach(({ href }) => (href = url));
  }

  handleBadges({ badges }) {
    const badgesContainer = badges.querySelector('.badges');
    this.badges.innerHTML = badgesContainer?.innerHTML || '';
  }
}

customElements.define('product-gem-picker', ProductGemPicker);
